import React, { FC } from 'react'
import styles from '../../SearchProvider.module.scss'
import Tick from 'svg/tick.svg'
import NoColorIcon from 'svg/SA/no-color-round.svg'
import classNames from 'classnames'
import {
  CustomHandleUpdateSelectedFacetParams,
  FacetOptionObject,
  FacetServiceApi,
  UseReduxSearchProviderResponse,
} from '../../types'
import { getHrefFunction, updateClientSideUrl } from '../../helpers/url'
import useReduxSearchProvider from '../../hooks/useReduxSearchProvider'

type FacetColorComponentProps = {
  baseUrl: string
  nextAppRoute: string
  facetService: FacetServiceApi
  facetName: string
  facetOptions: ReadonlyArray<FacetOptionObject>
  color: string
  isSelected: boolean
  useReduxProviderHook?: () => UseReduxSearchProviderResponse
  customHandleUpdateSelectedFacet?: (params: CustomHandleUpdateSelectedFacetParams) => void
  customClickFacetOption?: (params: CustomHandleUpdateSelectedFacetParams) => void
}

const FacetColorComponent: FC<FacetColorComponentProps> = ({
  baseUrl,
  nextAppRoute,
  facetService,
  facetName,
  facetOptions,
  color,
  isSelected,
  useReduxProviderHook = useReduxSearchProvider,
  customHandleUpdateSelectedFacet,
  customClickFacetOption,
}) => {
  const { selectedFacets, pathParams, sharedFacetNames, basicQueryParams } = useReduxProviderHook()

  const isAvailable = facetOptions.some(({ value }) => value === color)

  const handleUpdateSelectedFacets = ({
    newSelectedFacets,
    newQueryParams,
    facetName,
    facetValue,
  }) => {
    const newSelectedFacetsAndQueryParams = { ...newSelectedFacets, ...newQueryParams }
    const href = getHrefFunction({
      facetsAndQueryParams: newSelectedFacetsAndQueryParams,
      pathParams,
      sharedFacetNames,
    })()
    const newUrl = `${baseUrl}${href}`

    if (Boolean(customHandleUpdateSelectedFacet)) {
      customHandleUpdateSelectedFacet?.({
        newSelectedFacets: newSelectedFacetsAndQueryParams,
        newUrl,
        facetName,
        facetValue,
      })
      return
    }

    customClickFacetOption?.({
      newSelectedFacets: newSelectedFacetsAndQueryParams,
      newUrl,
      facetName,
      facetValue,
    })
    updateClientSideUrl(newUrl, nextAppRoute)
  }

  const handleClickColor = (ev: React.SyntheticEvent<HTMLElement>) => {
    ev.preventDefault()

    facetService.handleClickFacet({
      facetValue: color,
      facetName,
      selectedFacets,
      basicQueryParams,
      updateSelectedFacetsAndQueryParams: handleUpdateSelectedFacets,
      inputType: 'single',
    })
  }

  return isAvailable ? (
    <div
      className={classNames(styles.colorDesktop, styles.colorDesktopAvailable)}
      data-gtm-event='filter'
      data-gtm-info={`Color - ${color}`}
      onClick={handleClickColor}
      style={{ '--color-value': color } as React.CSSProperties}
    >
      <div
        className={classNames(styles.colorSected, {
          [styles.colorSectedVisible]: isSelected,
        })}
      >
        <Tick />
      </div>
    </div>
  ) : (
    <NoColorIcon className={styles.noColorIcon} />
  )
}

export default FacetColorComponent
